import React, { useState, useEffect } from 'react';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import Newpagination from '../../Components/Pagination/pagination.tsx';
import '../../Components/Button/button-style.scss';
import AddBillingModal from './add-billing-modal.tsx';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { SelectChangeEvent } from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import DescriptionIcon from '@mui/icons-material/Description'; 
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Box, Typography } from '@mui/material';
import { getBilledClients, getInvoices, getZohoSync } from './action.ts';

interface BillingProps {}

const Billing: React.FC<BillingProps> = (props) => {
  const [pageSize, setPageSize] = useState<string>('10');
  const [page, setPage] = useState<string>('0'); 
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [billings, setBillings] = useState<any[]>([]);
  const [selectedBilledClient, setSelectedBilledClient] = useState<string>('ALL');
  const [addBillingModalOpen, setAddBillingModalOpen] = useState(false);
  const [billedClientOptions, setBilledClientOptions] = useState<{id: string, label: string, uuid: string}[]>([]);
 const [refreshTrigger, setRefreshTrigger] = useState<number>(0);
  const showEntries = [
    { id: '10', label: '10' },
    { id: '20', label: '20' },
    { id: '50', label: '50' },
    { id: '100', label: '100' },
  ];

  const fetchBilledClientsData = async () => {
    try {
      getBilledClients(
        (response: any) => {
          const companiesData = response?.data || []; 
          
          const options = companiesData.map((item: any) => ({
            id: item.id.toString(),
            label: item.name,
            uuid: item.uuid || ''
          }));
          options.sort((a: any, b: any) => a.label.localeCompare(b.label));
          setBilledClientOptions([{ id: 'ALL', label: 'All', uuid: '' }, ...options]);
        },
        (error: any) => {
          toast.error("Failed to fetch companies");
        }
      );
    } catch (error) {
      console.error("Failed to fetch companies", error);
    }
  };    

  const fetchZohoSync = () => {
    getZohoSync(
      (response: any) => {
        console.log("Zoho sync response:", response);
      },
      (error: any) => {
        console.error("Zoho sync failed", error); 
        const errorMsg = typeof error === 'string' ? error : error?.message || "Zoho sync failed";
        toast.error(errorMsg);
      } 
    );
  };

  useEffect(() => {
    fetchBilledClientsData();
    fetchZohoSync();
  }, []);

  useEffect(() => {
    sessionStorage.removeItem('trips_active_tab');
    
    const fetchBillings = () => {
      const apiClientId = selectedBilledClient === 'ALL' ? '' : selectedBilledClient;
      getInvoices(
        apiClientId, 
        page, 
        pageSize,
        (response: any) => {
          const fetchedData = response?.data || (Array.isArray(response?.message) ? response?.message : []);
          
          setBillings(fetchedData);
          setTotalRecords(response?.total_count || fetchedData.length || 0);
        },
        (error: any) => {
          console.error("Failed to fetch billings", error);
          const errorMsg = typeof error === 'string' ? error : error?.message || "Failed to fetch billings";
          toast.error(errorMsg);
          setBillings([]);
          setTotalRecords(0);
        }
      );
    };

    fetchBillings();
  }, [page, pageSize, selectedBilledClient,refreshTrigger]);

  const rows = Array.isArray(billings) ? billings.map((billing: any, index: number) => {
    const cleanValue = (value: any) => (value === null || value === 'null' || value === undefined ? '' : value);
    console.log(billing.bill_generated_date);
let formattedDate = '';
if (billing.bill_generated_date) {
  const dateString = billing.bill_generated_date.split('T')[0]; 
  const [year, month, day] = dateString.split('-'); 
  formattedDate = `${day}-${month}-${year}`; 
}
    return {
      id: billing.id || index,
      sl_no: (Number(page) * Number(pageSize)) + index + 1,
      date: formattedDate,
      invoice_number: cleanValue(billing.invoices_id),
      client_name: cleanValue(billing.client_name),
      status: cleanValue(billing.paid_status),
      amount: cleanValue(billing.total_amount),
      invoice_pdf_filepath: cleanValue(billing.invoice_pdf_filepath), 
    };
  }) : [];

  const updatePageSize = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (!isNaN(Number(value))) {
      setPageSize(value);
      setPage('0');
    }
  };

  const handleBilledClientChange = (event: SelectChangeEvent<string>) => {
    setSelectedBilledClient(event.target.value);
    setPage('0');
  };

  const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage((newPage - 1).toString());
  };

  const handleClickOpen = () => {
    setAddBillingModalOpen(true);
  };

  const handleCloseAdd = () => {
    setAddBillingModalOpen(false);
  };

  const columns: GridColDef[] = [
    { field: 'sl_no', headerName: 'Sl.No', width: 70, headerAlign: 'center', align: 'center' },
    { field: 'date', headerName: 'Date', width: 120, headerAlign: 'center', align: 'center' },
    { field: 'invoice_number', headerName: 'Invoice Number', width: 180, headerAlign: 'center', align: 'center' },
    { field: 'client_name', headerName: 'Client Name', flex: 1, minWidth: 200, headerAlign: 'center', align: 'center' },
    { field: 'status', headerName: 'Status', width: 150, headerAlign: 'center', align: 'center' },
    { field: 'amount', headerName: 'Amount', width: 150, headerAlign: 'center', align: 'center' },
{
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: GridRenderCellParams) => {
        const filepath = params.row.invoice_pdf_filepath;
        const hasPdf = Boolean(filepath && filepath !== '');
        const pdfUrl = hasPdf ? `${global.billing_storage_url}${filepath}` : '';
        const handleViewPdfClick = () => {
          if (pdfUrl) {
            window.open(pdfUrl, '_blank', 'noopener,noreferrer');
          }
        };

        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              gap: '8px',
            }}
          >
            {hasPdf ? (
              <IconButton 
                color="primary" 
                sx={{ padding: '0px' }}
                onClick={handleViewPdfClick}
              >
                <DescriptionIcon /> 
              </IconButton>
            ) : null}
          </div>
        );
      },
    }
  ];

  return (
    <>   
      <Header />
      <div style={{ marginTop: "70px" }}>
        <Heading 
          title="Billing" 
          page='billing' 
          closeIcon="false"
          leftContent={
            <>
              <Box display="flex" alignItems="center" gap="15px">
                <Box display="flex" alignItems="center">
                  <Typography style={{ marginRight: '5px' }}>Clients</Typography>
                  <Dropdown
                    options={billedClientOptions}
                    selectedValue={selectedBilledClient}
                    handleChange={handleBilledClientChange}
                    width='150px'
                    height='40px'
                    searchable={true}
                  />
                </Box>
                <Box display="flex" alignItems="center">
                  <Typography style={{ marginRight: '5px' }}>Show Entries</Typography>
                  <Dropdown
                    options={showEntries}
                    selectedValue={pageSize}
                    handleChange={updatePageSize}
                    width='70px'
                    height='40px'
                  />
                </Box>
              </Box>
            </>
          } 
          rightContent={
            <>
              <Box sx={{ marginTop: { xs: '10px', sm: '0px', md: '10px', lg: '0px' } }}>
                <Button
                  className="custom-button"
                  style={{ backgroundColor: '#8B0000', color: 'white' }}
                  onClick={handleClickOpen}
                >
                  <AddIcon/>
                </Button>
              </Box>
            </>
          }  
        />
      </div>

      <Box className="table-container custom-data-grid" sx={{ 
        marginLeft: { xs: '10px', sm: '180px' },
        marginTop: '10px', 
        marginRight: '5px', 
        position: 'relative', 
        height: '500px', 
        overflowY: 'auto' 
      }}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={totalRecords}
          autoHeight={false}
          disableRowSelectionOnClick
          disableColumnResize
          hideFooterPagination
          classes={{
            columnHeader: 'red-header',
          }}
        />
      </Box>

      <div style={{ marginLeft: '50%', marginTop: '8px' }}> 
        <Newpagination
          rows={totalRecords}
          pageSize={pageSize}
          page={page}
          handlePageChange={handlePageClick}
        />
      </div>

      <NavBar selected='Billing' />

      <AddBillingModal 
        open={addBillingModalOpen} 
        onClose={handleCloseAdd} 
        billedClientOptions={billedClientOptions} 
        onSuccess={() => setRefreshTrigger(prev => prev + 1)}
        getClients={fetchBilledClientsData}
      />
    </>
  );
};

export default Billing;